import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { TagLogModel } from '../../../models';
import { TagLogService } from '../../../services/tag-log.service';

@Component({
    selector: 'app-tag-log-preview',
    templateUrl: './tag-log-preview.component.html',
    styleUrls: ['../../../components/layout/layout.component.scss']
})
export class TagLogPreviewComponent implements OnInit {
    private _tagLogId: number;
    model: TagLogModel = new TagLogModel();
    @Input()
    get TagLogId() {
        return this._tagLogId;
    }
    set TagLogId(value: number) {
        this._tagLogId = value;
        this.loadTagLog(this._tagLogId);
    }
    @Output()
    CloseForm = new EventEmitter<any>();
    public showSpinner: boolean = false;
    constructor(private tagLogService: TagLogService) { }

    ngOnInit() {

    }
    closeThisForm() {

        this.CloseForm.emit({ closed: 'closed' });
    }

    loadTagLog(id: number) {
        this.showSpinner = true;
        this.tagLogService.getTagLog(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.model = response.Data;
                console.log(this.model);
                // this.toastr.success(response.Message, "Success"); 
            });

    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tag-log-preview/tag-log-preview.component.ts